<template>
  <div class="hero-pet-page">
    <top-bar title="Heropet">
      <img src="@/assets/icon/medal-white.png" alt="medal icon">
    </top-bar>

    <BloodGroupGraph />

    <container class="hero-pet-header">
      <div class="row col-12 justify-content-center">
        <div class="col-md-4 col-xs-12 mb-3">
          <router-link
            class="btn btn-primary btn-block"
            :to="{ name: 'donation' }"
            style="width:353px;">เข้าร่วมเครือข่าย</router-link>
        </div>
      </div>
      <div class="col-sm-12 mt-3 mt-xs-1 mb-5 mb-xs-2 text-center">
        <p class="mb-5 mb-xs-0">เข้าร่วมเครือข่าย เพื่อความปลอดภัยเวลาต้องการเลือด และ เป็นผุ้บริจาคเพื่อช่วยเหลือผู้อื่น<span><img src="@/assets/logo/power-by-vremind.png" alt="power by vremind" style="height:20px;margin-left: 10px;"></span></p>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 mt-5">
        <h2>ทำเนียบสุดยอดนักบุญประจำเครือข่าย Smart Pet Blood Bank</h2>
      </div>
    </container>
    <container class="hero-divider">
      <div class="col-sm line d-none d-sm-block"></div>
      <div class="col-sm-4 title gold">
        <img src="@/assets/icon/medal-gold.png" alt="medal icon">
        Gold Medal
      </div>
      <div class="col-sm line d-none d-sm-block"></div>
    </container>
    <hero-pet-panel class="hero-panel" medal="gold" :showLoadMore="true" />
    <container class="hero-divider">
      <div class="col-sm line d-none d-sm-block"></div>
      <div class="col-sm-4 title">
        <img src="@/assets/icon/medal-silver.png" alt="medal icon">
        Silver Medal
      </div>
      <div class="col-sm line d-none d-sm-block"></div>
    </container>
    <hero-pet-panel class="hero-panel" medal="silver" :showLoadMore="true" />
    <container class="hero-divider">
      <div class="col-sm line d-none d-sm-block"></div>
      <div class="col-sm-4 title bronze">
        <img src="@/assets/icon/medal-bronze.png" alt="medal icon">
        Bronze Medal
      </div>
      <div class="col-sm line d-none d-sm-block"></div>
    </container>
    <hero-pet-panel class="hero-panel" medal="bronze" :showLoadMore="true" />
    <container class="hero-divider">
      <div class="col-sm line d-none d-sm-block"></div>
      <div class="col-sm-4 title red">
        <img src="@/assets/icon/medal-red.png" alt="medal icon">
        Red Medal
      </div>
      <div class="col-sm line d-none d-sm-block"></div>
    </container>
    <hero-pet-panel class="hero-panel" medal="red" :showLoadMore="true" />
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import Container from '@/components/Container.vue'
import HeroPetPanel from '@/components/HeroPetPanel.vue'
import BloodGroupGraph from '@/components/heropet/BloodGroupGraph.vue'

export default {
  name: 'HeroPet',
  components: {
    TopBar,
    Container,
    HeroPetPanel,
    BloodGroupGraph
  }
}
</script>

<style scoped lang="scss">
.hero-pet-page {
  background-color: $gray-100;
}

.hero-divider {
  margin-bottom: 0.5rem;
  .line {
    height: 1px;
    margin-top: 0rem;
    background-color: $gray-500;
  }
  .title {
    font-size: $h5-font-size;
    text-align: center;
    &.gold {
      color: $gold;
    }
    &.bronze {
      color: $bronze;
    }
    &.red {
      color: $primary;
    }
    img {
      height: 2rem;
    }
  }
}

.hero-panel {
  padding-bottom: 1rem;
}

.hero-pet-header {
  padding-top: 2rem;
  padding-bottom: 2rem;
  h2 {
    font-weight: $font-weight-light;
    font-family: $font-family-thai;
    font-size: $h4-font-size;
    text-align: center;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .hero-divider {
    margin-bottom: 2rem;
    .line {
      margin-top: 1rem;
    }
    .title {
      font-size: $h4-font-size;
      img {
        height: 2.5rem;
      }
    }
  }

  .hero-panel {
    padding-bottom: 2rem;
  }

  .hero-pet-header {
    h2 {
      font-size: $h2-font-size;
    }
  }
}
</style>
